<div
  #liveMessages
  class="live-messages"
  [class.expanded]="isExpanded"
  [class.shrank]="isShrank"
  [class.disintegrate-input]="isDisintegrate"
  [class.collapse-input]="isCollapse"
>
  <button
    class="expander center"
    [class.!opacity-100]="!isCollapse && haveCollapse"
    [class.closed]="isCollapse"
    appDebounceClick
    (debounceClick)="onChevronClick()"
    (mousedown)="onHoldExpander()"
    (mouseup)="onUnholdExpander()"
    (touchstart)="onHoldExpander()"
    (touchend)="onUnholdExpander()"
  >
    <img class="center" src="assets/images/icon-chevron-{{ isExpanded ? 'down' : 'up' }}.png" />
  </button>
  <ul>
    @for (message of messages; track $index) {
      <li [class.admin-message]="message.fromAdmin">
        <div class="name">{{ message.name }}:</div>
        <div class="content">{{ message.content }}</div>
      </li>
    }
  </ul>
  <div class="composer">
    <input
      type="text"
      (keyup.enter)="sendMessage()"
      [(ngModel)]="composedMessage"
      class="default-input"
      placeholder="Type your chat here"
      name="message"
    />
    <button class="btn-send" (click)="sendMessage()" [disabled]="composedMessage.length < 1">
      <img class="center" src="assets/images/icon-send.png" />
    </button>
  </div>
</div>
